/**
 * 框架扩展的store模块，将在vue实例生产之后动态注册到当前$store中
 */

export default {
	namespaced: true,
	
	state: {
		routeEffectTrigger: 0,
		effect: '',
		routeMaskerTrigger: 0,
		dialogs: []
	},

	mutations: {
		addDialog(state, dialog){
			state.dialogs.push(dialog)
		},
		
		removeDialog(state){
			state.dialogs.pop()
		},
		
		setRouterEffect(state, {trigger, effect}){
			Object.assign(state, {
				routeEffectTrigger: trigger,
				effect
			})
		},
		
		change(state, message){
			state.dialogs[0].props.props.value = message
		},
		
		removeRouterEffect(state, {trigger}){
			Object.assign(state, {
				routeMaskerTrigger: trigger,
			})
		}
	}
}